import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
import css from './box-notecard-prevent-close-popup.scss';
export function BoxNotecardPreventClosePopupComponent({
  open,
  handleConfirm,
  handleCancel
}) {
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    open: open,
    cancelText: "Continue designing a notecard",
    onConfirm: handleConfirm,
    onCancel: handleCancel,
    onClose: handleCancel,
    confirmText: "Yes, Cancel",
    dialogClassName: css.dialogClassName,
    rootContentClassName: css.content,
    buttonConfirmClassName: css.button,
    buttonCancelClassName: css.button,
    msg: "Keep in mind, if you cancel, you will lose all of your progress",
    title: "Are you sure you want to cancel designing a notecard?",
    showCloseButton: false
  });
}